import { ChevronUp, ChevronDown } from "lucide-react";

/**
 * Boutons ↑↓ pour réorganiser une carte dashboard.
 * Utilise CSS `order` pour positionner la carte à l'écran.
 * Usage:
 *   <div style={{ order: order.indexOf("mon-id") }}>
 *     <CardReorderControls id="mon-id" order={order} setOrder={setOrder} editMode={editMode} />
 *     <Card>...</Card>
 *   </div>
 */
export const CardReorderControls = ({ id, order, setOrder, editMode, save }) => {
  if (!editMode) return null;
  const idx = order.indexOf(id);
  const moveUp = () => {
    if (idx <= 0) return;
    const n = [...order];
    [n[idx - 1], n[idx]] = [n[idx], n[idx - 1]];
    setOrder(n);
    save && save(n);
  };
  const moveDown = () => {
    if (idx < 0 || idx >= order.length - 1) return;
    const n = [...order];
    [n[idx + 1], n[idx]] = [n[idx], n[idx + 1]];
    setOrder(n);
    save && save(n);
  };
  return (
    <div className="absolute top-2 right-2 z-20 flex flex-col gap-1 bg-white/95 rounded-lg border border-indigo-300 shadow-md p-1" data-testid={`reorder-controls-${id}`}>
      <button
        type="button"
        onClick={moveUp}
        disabled={idx <= 0}
        className="p-1 rounded hover:bg-indigo-50 disabled:opacity-30 disabled:cursor-not-allowed"
        title="Monter"
        data-testid={`reorder-up-${id}`}
      >
        <ChevronUp className="w-4 h-4 text-indigo-700" />
      </button>
      <button
        type="button"
        onClick={moveDown}
        disabled={idx < 0 || idx >= order.length - 1}
        className="p-1 rounded hover:bg-indigo-50 disabled:opacity-30 disabled:cursor-not-allowed"
        title="Descendre"
        data-testid={`reorder-down-${id}`}
      >
        <ChevronDown className="w-4 h-4 text-indigo-700" />
      </button>
    </div>
  );
};
